import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { fetchRules } from "../../../lib/api/resources/rules";
import { ruleColumns } from "./lib/constants/ruleColumns";
import { Link } from "react-router-dom";
import { useState } from "react";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";

export const RulesList = () => {
  const [page, setPage] = useState(1);

  const rulesQuery = useQuery({
    queryKey: ["rules", page],
    queryFn: () => fetchRules({ page }),
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/rules/create">
          <Button icon={<PlusOutlined />}>Nieuwe regel</Button>
        </Link>
      </Space>
      <Table
        columns={ruleColumns}
        dataSource={rulesQuery.data?.member}
        loading={rulesQuery.isLoading}
        pagination={{
          pageSize: 15,
          total: rulesQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
        rowKey="id"
      />
    </div>
  );
};
